export const defaultTheme = {
    "colorSettings": {
        "primary": "#004780",
        "secondary": "#00a1c0",
        "primaryLight": "#e1e9f0"
    }
};